import React from 'react';

export const splitTextToParagraphsOnLinebreak = text =>
  (text ? text : '').split('\n').map((textFragment, i) => <p key={i}>{textFragment}</p>);

const regexMap = new Map([
  ['http:',/(http?:\/\/[^\s]+)/g],
  ['https:',/(https?:\/\/[^\s]+)/g],
  ['www',/( www\.[^\s]+)/g]
])
const replaceLinks = (textFragment) => 
{
  regexMap.forEach((value, key) => {

    if(textFragment.indexOf(key) > -1)
    {
        textFragment = textFragment.replace(value, function(url) { 
          const linkUrl =  url.trim().startsWith('www') ? 'https://' + url.trim() : url.trim()
          return '<a href="' + (linkUrl.endsWith('.') ? linkUrl.slice(0,-1) : linkUrl) + '" target="_blank">' + url + '</a>';
      }) 
    }
  });

  return textFragment
}

export const splitTextToParagraphsOnLinebreakAndGenerateLinks = text =>
{  
  return (text ? text : '').split('\n').map((textFragment, i) => <p key={i}>{
      replaceLinks(textFragment)
    }</p>);
}

// Regexps for numbers that accept both comma (,) and dot (.) as decimal separators:
export const regExpForNumberWithUnlimitedDecimals = '[\\d]+([,\\.]{1}[\\d]*)?';
export const regExpForNumberWithThreeDecimals = '[\\d]+([,\\.]{1}[\\d]{0,3})?';
